// -----------------------------------------------------------------------------
// Scripts for search form
// -----------------------------------------------------------------------------

$(function () {
  $('.header-contact__search').on('click',function () {
    $('.search-form').fadeIn(300);
    $('.search-form').addClass('search-form--open');

    setTimeout(function() {
      $('body').addClass('no-scroll');
    }, 450);
  });

  $('.search-form__close').on('click', function () {
    $('.search-form').removeClass('search-form--open');

    setTimeout(function() {
      $('.search-form').fadeOut(300);
      $('body').removeClass('no-scroll');
    }, 450);
  });
});